import { Modifier } from 'draft-js';
import { Editor, EditorState } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useTranslation } from 'react-i18next';

type Props = {
  onChange: (editorState: EditorState) => void;
  editorState: any;
};

export default function TextEditor(props: Readonly<Props>) {
  const { onChange, editorState } = props;
  const { t } = useTranslation();

  const handlePastedText = (
    text: string,
    _html: string,
    currentState: EditorState // This is the critical fix
  ) => {
    try {
      const contentState = currentState.getCurrentContent();
      const selection = currentState.getSelection();

      const newContentState = Modifier.replaceText(
        contentState,
        selection,
        text,
        currentState.getCurrentInlineStyle().merge(['Century Gothic'])
      );

      const newEditorState = EditorState.push(
        currentState, // Use the callback's currentState
        newContentState,
        'insert-fragment'
      );

      onChange(newEditorState);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };
  return (
    <Editor
      editorStyle={{
        maxHeight: '60vh',
      }}
      handlePastedText={handlePastedText} // Add this prop
      editorState={editorState}
      onEditorStateChange={onChange}
      wrapperClassName="flex-col "
      editorClassName="border-2 scrollbar border-grey-input_border text-center text-base pl-3 rounded-l-md rounded-b-md rounded-r-md"
      toolbarClassName="flex"
      placeholder={t('topics.header_card_placeholder')}
      toolbar={{
        options: ['inline', 'list', 'emoji', 'link'],
        inline: {
          options: ['bold', 'italic', 'underline'],
        },
        list: {
          inDropdown: false,
          className: undefined,
          component: undefined,
          dropdownClassName: undefined,
          options: ['unordered', 'ordered'],
        },
        // link: { options: ["link"] },
      }}
    />
  );
}
